import { createFileRoute, redirect } from "@tanstack/react-router";
import { hasModule, firstAllowedRoute } from "@/lib/auth";
import { DocumentCheckClient } from "@/features/documentCheck/DocumentCheckClient";

// Transport → Documentcontrole (docs/scantafel.md §4, §10): the scans without a consignment, linked one by one. The same
// rights as Palletcontrole, its second step: reading takes documents or dossiers and tms_orders; linking takes
// dossiers_write and tms_orders_write.
export const Route = createFileRoute("/_shell/document-check")({
  beforeLoad: ({ context }) => {
    const documents = hasModule(context.session, "documents") || hasModule(context.session, "dossiers") || hasModule(context.session, "dossiers_write");
    const orders = hasModule(context.session, "tms_orders") || hasModule(context.session, "tms_orders_write");
    if (!documents || !orders) throw redirect({ to: firstAllowedRoute(context.session) });
  },
  component: DocumentCheckScreen,
});

function DocumentCheckScreen() {
  const { session } = Route.useRouteContext();
  return (
    <div className="wl-page wl-page--list" data-screen-label="Back-office Scan Desk">
      <DocumentCheckClient step="link" userId={session.userId} canWrite={hasModule(session, "dossiers_write") && hasModule(session, "tms_orders_write")} />
    </div>
  );
}
